import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Home.css";
import { useAuth } from "../components/authContext";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";

const logo = "https://ab-v2-images.s3.us-east-2.amazonaws.com/static_images/abv2logo.png";
const heroVideo = "https://d33rg8nmajebl8.cloudfront.net/video/hero_ab_v2.mp4";

const Home = () => {
  const { user } = useAuth(); // null/undefined when signed out
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const vid = videoRef.current;
    if (!vid) return;
    vid.muted = muted;
    if (!isPaused) {
      vid.play().catch(() => {});
    } else {
      vid.pause();
    }
  }, [muted, isPaused]);

  return (
    <div className="home-container">
      {/* Logo */}
      <img className="logo" src={logo} alt="ActivityBuddy Logo" />

      {/* Tagline */}
      <h2 className="home-title">You don’t just create content. You create presence.</h2>

      {/* Subtitle */}
      <p className="home-subtitle">
        ActivityBuddy gives you a free private, curated link where fans can
        request to spend time with you doing what you love on your terms, in your
        world.
      </p>

      {/* Hero video */}
      <div className="home-hero-video">
        <video
          ref={videoRef}
          src={heroVideo}
          autoPlay
          muted
          loop
          playsInline
          controls={false}
          />
        <div className="home-hero-controls home-hero-controls-left">
          <button
            onClick={() => setIsPaused(p => !p)}
            aria-label={isPaused ? "Play video" : "Pause video"}
          >
            {isPaused ? <PlayArrowIcon fontSize="small" /> : <PauseIcon fontSize="small" />}
          </button>
        </div>
        <div className="home-hero-controls home-hero-controls-right">
          <button
            onClick={() => setMuted(m => !m)}
            aria-label={muted ? "Unmute video" : "Mute video"}
          >
            {muted ? <VolumeOffIcon fontSize="small" /> : <VolumeUpIcon fontSize="small" />}
          </button>
        </div>
      </div>

      {/* Buttons + footer change based on auth */}
      {user ? (
        <>
          <div className="home-buttons">
            <Link to="/dashboard/" className="btn btn-primary">
              Go To Dashboard
            </Link>
          </div>
          {/* No footer note when signed in */}
        </>
      ) : (
        <>
          <div className="home-buttons">
            <Link to="/apply" className="btn btn-primary">
              Apply to Join
            </Link>
            <Link to="/login" className="btn btn-secondary">
              Sign In
            </Link>
          </div>
          <p className="home-footer-note">
            We review every application to keep our community safe & high quality.
          </p>
        </>
      )}
      <div className="home-legal-links">
        <Link to="/trust-safety" target="_blank" rel="noreferrer">Trust &amp; Safety</Link>
        <span className="home-legal-dot">·</span>
        <Link to="/terms" target="_blank" rel="noreferrer">Terms</Link>
        <span className="home-legal-dot">·</span>
        <Link to="/privacy" target="_blank" rel="noreferrer">Privacy</Link>
      </div>
    </div>
  );
};

export default Home;
